@if(!isOnHome){
    <div class="page-title-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="page-title-content text-white">
                        <h2>Contactez-nous</h2>
                        <ul class="text-gray-200">
                            <li><a routerLink="/" class="hover:underline">Accueil</a></li>
                            <li>Contact</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

<div class="container py-5" id="contact">
    <div class="section-title">
        @if(isOnHome){
            <h2>Contactez ASESA</h2>
            <div class="bar"></div>
        }
        <p>Vous souhaitez en savoir plus sur nos actions ou soutenir ASESA ? Écrivez-nous directement via WhatsApp.</p>
    </div>

    <div class="row align-items-center">
        <!-- Formulaire -->
        <div class="col-lg-6">
            <div class="contact-form">
                <form [formGroup]="contactForm" (ngSubmit)="redirectToWhatsApp()">

                    <div class="row">
                        <div class="col-lg-6">
                            <input type="text" formControlName="prenom" class="form-control" placeholder="Prénom *" required>
                        </div>

                        <div class="col-lg-6">
                            <input type="text" formControlName="nom" class="form-control" placeholder="Nom *" required>
                        </div>

                        <div class="col-lg-12">
                            <input type="email" formControlName="email" class="form-control" placeholder="Adresse email *" required>
                        </div>

                        <div class="col-lg-12">
                            <input type="text" formControlName="objet" class="form-control" placeholder="Objet du message">
                        </div>

                        <div class="col-lg-12">
                            <textarea formControlName="message" rows="5" class="form-control" placeholder="Votre message *" required></textarea>
                        </div>

                        <div class="col-lg-12 mt-3">
                            <button type="submit" class="default-btn" [disabled]="contactForm.invalid">
                                Contacter via WhatsApp <span></span>
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>

        <!-- Infos contact -->
        <div class="col-lg-6">
            <div class="contact-info">
                <h3>Coordonnées officielles ASESA</h3>
                <p>
                    📍 Morétan – Commune Est-Mono 2, Togo<br>
                    📞 <strong></strong> +228 91 18 12 92<br>
                    ✉️ <a href="mailto:Asesatogo25@gmail.com">Asesatogo25&#64;gmail.com</a>
                </p>
                <p>
                    <em>Nous vous répondrons dans les meilleurs délais.</em>
                </p>
            </div>
        </div>
    </div>
</div>
